module.exports = __webpack_public_path__ + "img/borrar.652dc3c8.png";